import 'jquery-ui-sortable'

export default class ArticleJobsPriorities {
  constructor(params) {
    this.params = params;
  }

  show(){
    if ($('.js-locked').length < $('.js-single-article').length ){
      $( ".js-article-list" ).sortable({
        items: ".js-single-article:not(.js-disabled)"
      });
      this.bindSave()
      this.bindReset()
    }
  }

  orderItems() {
    let itemElems = $( ".js-article-list .js-single-article" )
    let list = []
    $( itemElems ).each( function( i, itemElem ) {
      let obj = {}
      let id = $(itemElem).data('articleId')
      obj[id] = i + 1
      list.push(obj)
    });
    this.saveList(list)
  }

  saveList(list) {
    let pub_id = $(".js-article-list").data('pub-id')
    let url = '/article_jobs/priorities/' + pub_id
    let form = new N2Styles.manualForm(url)
    list.forEach(function(item) {
      for (var k in item){
        form.addInput('priority_list[ids][' + k +']', item[k]);
      }
    })

    form.patch()
  }

  bindSave() {
    N2.bindHandler('click', '.js-save-priorities', (e) => {
      this.orderItems()
    })
  }

  bindReset(){
    N2.bindHandler("click", '.js-reset-priorities', (e) => {
      N2.navigate(location.href)
    })
  }
}
